export const errorMessages = {
  "COMBINATION_OF_PROJECT_NAME_AND_CODE_ALREADY_EXISTS": "Combination of project name and code already exists",
  "CLIENT_NAME_ALREADY_EXISTS": " Client name already exists",
} as const;

 export type ErrorMessageKey = keyof typeof errorMessages;
